import { TAdFoxBannerTemplate } from '@cian/adfox-component';
import { AdFoxTemplates } from '@cian/adfox-templates';
import { useDeviceType } from '@cian/ui-kit';
import { Base64 } from 'js-base64';
import * as React from 'react';
import { useApplicationContext } from 'shared/map-search/containers/ApplicationContext';

import { SpecialProjectTemplate } from '../SpecialProjectTemplate';
import { SPECIAL_PROJECT_TYPE, type TOwnTemplateContext } from '../bannerTemplateTypes';

const OWN_BUNDLE_NAMES = ['banner.transfer'];
const OWN_TYPES: TOwnTemplateContext['type'][] = [SPECIAL_PROJECT_TYPE];

export const OwnTemplates: React.FC<TAdFoxBannerTemplate> = props => {
  const { bundleName, bundleParams } = props;
  const deviceType = useDeviceType();
  const { logger } = useApplicationContext();

  if (bundleName && OWN_BUNDLE_NAMES.includes(bundleName) && bundleParams?.htmlBase64) {
    try {
      const decoded = Base64.decode(bundleParams.htmlBase64);
      const parsed = JSON.parse(decoded);

      if (isParsedParamsValid(parsed) && OWN_TYPES.includes(parsed.type)) {
        switch (parsed.type) {
          case SPECIAL_PROJECT_TYPE:
            return <SpecialProjectTemplate context={parsed} />;
        }
      }
    } catch (error) {
      logger.error(error, {
        bannerId: bundleParams.bannerId,
        domain: 'shared/map-search/Adfox/components/templates/OwnTemplates/OwnTemplates.tsx',
        message: '[AdFox] Failed to decode/parse bundleParams',
      });

      return null;
    }
  }

  return <AdFoxTemplates deviceType={deviceType} {...props} />;
};

function isParsedParamsValid(params: unknown): params is TOwnTemplateContext {
  return typeof params === 'object' && params !== null && 'type' in params;
}
